import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {WorkerPage} from '../../model/pagination/worker/worker-page.model';

@Injectable()
export class WorkersPageResolver implements Resolve<Observable<WorkerPage>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<WorkerPage> {
    const pageIndex = route.queryParams['pageIndex'] ?? 0;
    const pageSize = route.queryParams['pageSize'] ?? 20;
    const query = route.queryParams['search'];
    return this.facadeService.getPageWorkers(pageIndex, pageSize, {query: query}).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
